export const textColor = '#282828';
export const appBgColor = '#eff2f7';
export const green = '#52b36b';
export const lightGreen = '#5cb082';
export const orange = '#ef8031';
export const lightOrange = '#f9a31d';
export const red = '#be2727';
export const brightRed = '#d01e1e';
export const lightBlue = '#7a89a7';
